// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 检查是否需要初始化管理员 GET /api/admin/auth/check-setup */
export async function checkAdminSetup(options?: { [key: string]: any }) {
  return request<API.BackendResponse<{ needsSetup: boolean }>>('/api/admin/auth/check-setup', {
    method: 'GET',
    skipErrorHandler: true,
    ...(options || {}),
  });
}

/** 初始化管理员账号 POST /api/admin/auth/setup */
export async function adminSetup(
  body: { username: string; email: string; password: string },
  options?: { [key: string]: any },
) {
  return request<API.LoginResult>('/api/admin/auth/setup', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: body,
    skipErrorHandler: true,
    ...(options || {}),
  });
}

/** 获取当前管理员信息 GET /api/admin/auth/me */
export async function currentUser(options?: { [key: string]: any }) {
  return request<API.BackendResponse<{ user: any }>>('/api/admin/auth/me', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 管理员退出登录 POST /api/admin/auth/logout */
export async function outLogin(options?: { [key: string]: any }) {
  return request<API.BackendResponse>('/api/admin/auth/logout', {
    method: 'POST',
    ...(options || {}),
  });
}

/** 管理员登录接口 POST /api/admin/auth/login */
export async function login(body: API.LoginParams, options?: { [key: string]: any }) {
  return request<API.LoginResult>('/api/admin/auth/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      email: body.email,
      password: body.password,
    },
    // 登录接口跳过全局错误处理，由页面自行处理
    skipErrorHandler: true,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /api/notices */
export async function getNotices(options?: { [key: string]: any }) {
  return request<API.NoticeIconList>('/api/notices', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取规则列表 GET /api/rule */
export async function rule(
  params: {
    // query
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.RuleList>('/api/rule', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新规则 PUT /api/rule */
export async function updateRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'update',
      ...(options || {}),
    },
  });
}

/** 新建规则 POST /api/rule */
export async function addRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'post',
      ...(options || {}),
    },
  });
}

/** 删除规则 DELETE /api/rule */
export async function removeRule(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/rule', {
    method: 'POST',
    data: {
      method: 'delete',
      ...(options || {}),
    },
  });
}

// ============ 用户管理 API（CRM 管理后台） ============

/** 获取用户列表 GET /api/admin/users */
export async function getAdminUsers(
  params: {
    current?: number;
    pageSize?: number;
    keyword?: string;
    status?: string;
    isPaid?: string;
    sorter?: string;
    referralCode?: string;
    referredByUid?: string;
    referredByCode?: string;
    createdAtStart?: string;
    createdAtEnd?: string;
    deletedAtStart?: string;
    deletedAtEnd?: string;
  },
  options?: { [key: string]: any },
) {
  return request<API.AdminUserListResult>('/api/admin/users', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

/** 获取用户详情 GET /api/admin/users/:id */
export async function getAdminUserDetail(
  id: string,
  options?: { [key: string]: any },
) {
  return request<API.AdminUserDetailResult>(`/api/admin/users/${id}`, {
    method: 'GET',
    ...(options || {}),
  });
}

/**
 * Excel 批量导入老系统用户 POST /api/admin/users/import
 * CRM 端先用 xlsx 解析为 JSON 行再提交，单次最多 2000 行。
 */
export async function importAdminUsers(
  data: {
    users: Array<{
      email: string;
      btcBalance: number;
      registeredAt?: string;
    }>;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    data?: {
      total: number;
      success: number;
      skipped: number;
      failed: number;
      failures: Array<{ row: number; email: string; reason: string }>;
    };
    error?: string;
  }>('/api/admin/users/import', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

/** 更新用户状态 PATCH /api/admin/users/:id/status */
export async function updateAdminUserStatus(
  id: string,
  status: string,
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse>(`/api/admin/users/${id}/status`, {
    method: 'PATCH',
    data: { status },
    ...(options || {}),
  });
}

/** 更新用户返佣开关 PATCH /api/admin/users/:id/referral-flags */
export async function updateAdminUserReferralFlags(
  id: string,
  data: { acceptCommission?: boolean; upwardCommission?: boolean },
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse>(`/api/admin/users/${id}/referral-flags`, {
    method: 'PATCH',
    data,
    ...(options || {}),
  });
}

/** 设置用户收益降低百分比 PATCH /api/admin/users/:id/yield-reduction */
export async function updateAdminUserYieldReduction(
  id: string,
  data: { yieldReductionPercent: number },
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse>(`/api/admin/users/${id}/yield-reduction`, {
    method: 'PATCH',
    data,
    ...(options || {}),
  });
}

/** 彻底删除用户及其所有数据（仅开发环境）DELETE /api/admin/users/:id */
export async function deleteAdminUser(
  id: string,
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse>(`/api/admin/users/${id}`, {
    method: 'DELETE',
    ...(options || {}),
  });
}

/** 重置用户上级绑定（解绑邀请人）POST /api/admin/users/:id/reset-referrer */
export async function resetAdminUserReferrer(
  id: string,
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse>(`/api/admin/users/${id}/reset-referrer`, {
    method: 'POST',
    ...(options || {}),
  });
}

/** 获取用户交易记录 GET /api/admin/users/:id/transactions */
export async function getAdminUserTransactions(
  id: string,
  params?: {
    current?: number;
    pageSize?: number;
    type?: string;
    currency?: string;
  },
  options?: { [key: string]: any },
) {
  return request<API.AdminTransactionListResult>(`/api/admin/users/${id}/transactions`, {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

/** 获取用户提现记录 GET /api/admin/users/:id/withdrawals */
export async function getAdminUserWithdrawals(
  id: string,
  params?: {
    current?: number;
    pageSize?: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.AdminWithdrawalListResult>(`/api/admin/users/${id}/withdrawals`, {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

/** 获取用户矿机列表 GET /api/admin/users/:id/miners */
export async function getAdminUserMiners(
  id: string,
  params?: {
    current?: number;
    pageSize?: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.AdminMinerListResult>(`/api/admin/users/${id}/miners`, {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

/** 获取用户挖矿会话列表 GET /api/admin/users/:id/mining */
export async function getAdminUserMiningSessions(
  id: string,
  params?: {
    current?: number;
    pageSize?: number;
    status?: string;
  },
  options?: { [key: string]: any },
) {
  return request<API.AdminUserMiningResult>(`/api/admin/users/${id}/mining`, {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

// ============ 矿机产品管理 API（CRM 管理后台） ============

/** 获取用户订单列表 GET /api/admin/users/:id/orders */
export async function getAdminUserOrders(
  id: string,
  params?: {
    current?: number;
    pageSize?: number;
  },
  options?: { [key: string]: any },
) {
  return request<{ success: boolean; data: any[]; total: number }>(`/api/admin/users/${id}/orders`, {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

/** 获取用户直推用户列表 GET /api/admin/users/:id/direct-referrals */
export async function getAdminUserDirectReferrals(
  id: string,
  params?: {
    current?: number;
    pageSize?: number;
  },
  options?: { [key: string]: any },
) {
  return request<{ success: boolean; data: any[]; total: number }>(`/api/admin/users/${id}/direct-referrals`, {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

/** 获取用户裂变用户列表 GET /api/admin/users/:id/fission-users */
export async function getAdminUserFissionUsers(
  id: string,
  params?: {
    current?: number;
    pageSize?: number;
    level?: number;
  },
  options?: { [key: string]: any },
) {
  return request<{ success: boolean; data: any[]; total: number }>(`/api/admin/users/${id}/fission-users`, {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

/** 管理员发放矿机给用户 POST /api/admin/users/:id/grant-miner */
export async function grantAdminUserMiner(
  id: string,
  data: { productId: string },
  options?: { [key: string]: any },
) {
  return request<{ success: boolean; data: any; error?: string }>(`/api/admin/users/${id}/grant-miner`, {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

/** 管理员「订单矿机」：已支付订单 + 矿机（不创建挖矿会话） POST /api/admin/users/:id/grant-order-miner */
export async function grantAdminUserOrderMiner(
  id: string,
  data: {
    productId: string;
    purchasedAt: string;
    minerStartTime: string;
    minerEndTime: string;
    paymentMethod: string;
    payAmount?: number;
    quantity?: number;
  },
  options?: { [key: string]: any },
) {
  return request<{ success: boolean; data?: any; error?: string }>(
    `/api/admin/users/${id}/grant-order-miner`,
    {
      method: 'POST',
      data,
      ...(options || {}),
    },
  );
}

/** 获取矿机产品列表 GET /api/admin/miners/products */
export async function getAdminMinerProducts(
  params: {
    current?: number;
    pageSize?: number;
    productModel?: string;
    productType?: string;
    isAvailable?: string;
    sorter?: string;
  },
  options?: { [key: string]: any },
) {
  return request<API.AdminMinerProductListResult>('/api/admin/miners/products', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

/** 获取矿机产品详情 GET /api/admin/miners/products/:id */
export async function getAdminMinerProductDetail(
  id: string,
  options?: { [key: string]: any },
) {
  return request<API.AdminMinerProductDetailResult>(`/api/admin/miners/products/${id}`, {
    method: 'GET',
    ...(options || {}),
  });
}

/** 创建矿机产品 POST /api/admin/miners/products */
export async function createAdminMinerProduct(
  data: Record<string, any>,
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse>('/api/admin/miners/products', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

/** 更新矿机产品 PUT /api/admin/miners/products/:id */
export async function updateAdminMinerProduct(
  id: string,
  data: Record<string, any>,
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse>(`/api/admin/miners/products/${id}`, {
    method: 'PUT',
    data,
    ...(options || {}),
  });
}

/** 删除矿机产品 DELETE /api/admin/miners/products/:id */
export async function deleteAdminMinerProduct(
  id: string,
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse>(`/api/admin/miners/products/${id}`, {
    method: 'DELETE',
    ...(options || {}),
  });
}

/** 切换矿机产品上架/下架 PATCH /api/admin/miners/products/:id/availability */
export async function toggleAdminMinerProductAvailability(
  id: string,
  isAvailable: boolean,
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse>(`/api/admin/miners/products/${id}/availability`, {
    method: 'PATCH',
    data: { isAvailable },
    ...(options || {}),
  });
}

/** 增加矿机产品库存 PATCH /api/admin/miners/products/:id/inventory */
export async function addAdminMinerProductInventory(
  id: string,
  amount: number,
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse>(`/api/admin/miners/products/${id}/inventory`, {
    method: 'PATCH',
    data: { amount },
    ...(options || {}),
  });
}

/** 减少矿机产品库存 PATCH /api/admin/miners/products/:id/reduce-inventory */
export async function reduceAdminMinerProductInventory(
  id: string,
  amount: number,
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse>(`/api/admin/miners/products/${id}/reduce-inventory`, {
    method: 'PATCH',
    data: { amount },
    ...(options || {}),
  });
}

/** 同步矿机产品到 BagelPay POST /api/admin/miners/products/:id/sync-bagelpay */
export async function syncAdminMinerProductBagelPay(
  id: string,
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse>(`/api/admin/miners/products/${id}/sync-bagelpay`, {
    method: 'POST',
    ...(options || {}),
  });
}

// ============ 订单管理 API（CRM 管理后台） ============

/** 获取订单列表 GET /api/admin/orders */
export async function getAdminOrders(
  params: {
    current?: number;
    pageSize?: number;
    orderId?: string;
    userId?: string;
    email?: string;
    type?: string;
    status?: string;
    isFirstOrder?: string;
    createdStart?: string;
    createdEnd?: string;
    sorter?: string;
  },
  options?: { [key: string]: any },
) {
  return request<API.AdminOrderListResult>('/api/admin/orders', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

/** 获取订单详情 GET /api/admin/orders/:id */
export async function getAdminOrderDetail(
  id: string,
  options?: { [key: string]: any },
) {
  return request<API.AdminOrderDetailResult>(`/api/admin/orders/${id}`, {
    method: 'GET',
    ...(options || {}),
  });
}

/**
 * 管理员手动完成订单（用户已支付但回调未到的兜底操作）
 * POST /api/admin/orders/:id/complete
 *
 * @param grantMiner 仅 miner 类型订单需要：true=按购买流程发放矿机；false=只标记为已支付，不再发放矿机
 */
export async function manualCompleteAdminOrder(
  id: string,
  grantMiner: boolean,
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    data?: { orderId: string; miners?: number; ticketAmount?: number };
    error?: string;
  }>(`/api/admin/orders/${id}/complete`, {
    method: 'POST',
    data: { grantMiner },
    ...(options || {}),
  });
}

/**
 * 管理员手动退款 Google Pay 订单
 * POST /api/admin/orders/:id/refund
 */
export async function manualRefundAdminOrder(
  id: string,
  reason: string,
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    data?: { orderId: string; clawbackBtc: number; newBalanceBtc: number; withdrawFrozen: boolean };
    error?: string;
  }>(`/api/admin/orders/${id}/refund`, {
    method: 'POST',
    data: { reason },
    ...(options || {}),
  });
}

/**
 * 管理员手动重新 Consume Google Pay 订单
 * POST /api/admin/orders/:id/google-consume
 */
export async function reconsumeGoogleAdminOrder(
  id: string,
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    data?: { orderId: string; consumed?: boolean; refunded?: boolean; clawbackBtc?: number; alreadyConsumed?: boolean };
    error?: string;
  }>(`/api/admin/orders/${id}/google-consume`, {
    method: 'POST',
    ...(options || {}),
  });
}

// ============ 提现管理 API（CRM 管理后台） ============

/** 获取待审核提现列表 GET /api/admin/withdrawals/pending */
export async function getAdminPendingWithdrawals(
  params: {
    current?: number;
    pageSize?: number;
    nickname?: string;
    currency?: string;
    sorter?: string;
  },
  options?: { [key: string]: any },
) {
  return request<API.AdminWithdrawalPendingListResult>('/api/admin/withdrawals/pending', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

/** 获取提现历史记录 GET /api/admin/withdrawals/history */
export async function getAdminWithdrawalHistory(
  params: {
    current?: number;
    pageSize?: number;
    nickname?: string;
    currency?: string;
    status?: string;
    chainScanTransferStatus?: string;
    sorter?: string;
  },
  options?: { [key: string]: any },
) {
  return request<API.AdminWithdrawalHistoryListResult>('/api/admin/withdrawals/history', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

/** 审批提现（通过） POST /api/admin/withdrawals/:id/approve */
export async function approveAdminWithdrawal(
  id: string,
  txHash?: string,
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse>(`/api/admin/withdrawals/${id}/approve`, {
    method: 'POST',
    data: txHash ? { txHash } : {},
    ...(options || {}),
  });
}

/** 拒绝提现 POST /api/admin/withdrawals/:id/reject */
export async function rejectAdminWithdrawal(
  id: string,
  reason: string,
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse>(`/api/admin/withdrawals/${id}/reject`, {
    method: 'POST',
    data: { reason },
    ...(options || {}),
  });
}

/** 运营兜底「手动转账」，跳过 chain-scan 直接置 COMPLETED POST /api/admin/withdrawals/:id/manual-transfer */
export async function manualTransferAdminWithdrawal(
  id: string,
  txHash: string,
  note?: string,
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse>(
    `/api/admin/withdrawals/${id}/manual-transfer`,
    {
      method: 'POST',
      data: { txHash, ...(note ? { note } : {}) },
      ...(options || {}),
    },
  );
}

/** 重新通过 chain-scan 出币 POST /api/admin/withdrawals/:id/retry-chain-scan */
export async function retryWithdrawalChainScan(
  id: string,
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse>(`/api/admin/withdrawals/${id}/retry-chain-scan`, {
    method: 'POST',
    ...(options || {}),
  });
}

/** 实时查询 chain-scan 端状态 GET /api/admin/withdrawals/:id/chain-scan-status */
export async function getWithdrawalChainScanStatus(
  id: string,
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse>(`/api/admin/withdrawals/${id}/chain-scan-status`, {
    method: 'GET',
    ...(options || {}),
  });
}

/** 批量审批提现 POST /api/admin/withdrawals/batch-approve */
export async function batchApproveAdminWithdrawals(
  ids: string[],
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse>('/api/admin/withdrawals/batch-approve', {
    method: 'POST',
    data: { ids },
    ...(options || {}),
  });
}

/** 初始化提现 btcPriceAtCreate POST /api/admin/withdrawals/:id/init-price */
export async function initAdminWithdrawalPrice(
  id: string,
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse<{ id: string; btcPriceAtCreate: number }>>(`/api/admin/withdrawals/${id}/init-price`, {
    method: 'POST',
    ...(options || {}),
  });
}

// ============ 活动管理 API（CRM 管理后台） ============

// --- 社交活动 ---

/** 获取社交活动期次列表 GET /api/admin/activities/social/periods */
export async function getAdminSocialPeriods(
  params: {
    current?: number;
    pageSize?: number;
    status?: string;
  },
  options?: { [key: string]: any },
) {
  return request<API.AdminSocialPeriodsResult>('/api/admin/activities/social/periods', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

/** 创建社交活动期次 POST /api/admin/activities/social/periods */
export async function createAdminSocialPeriod(
  data: { title: string; startTime: string; endTime: string },
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse>('/api/admin/activities/social/periods', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

/** 获取社交活动期次详情 GET /api/admin/activities/social/periods/:id */
export async function getAdminSocialPeriodDetail(
  id: string,
  params?: { current?: number; pageSize?: number },
  options?: { [key: string]: any },
) {
  return request<API.AdminSocialPeriodDetailResult>(`/api/admin/activities/social/periods/${id}`, {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

/** 发放社交活动提交奖励 POST /api/admin/activities/social/submissions/:id/reward */
export async function rewardAdminSocialSubmission(
  id: string,
  data: { amount: number; currency: string },
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse>(`/api/admin/activities/social/submissions/${id}/reward`, {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

// --- 每日奖池 ---

/** 获取每日奖池期次列表 GET /api/admin/activities/daily-pool/periods */
export async function getAdminDailyPoolPeriods(
  params: {
    current?: number;
    pageSize?: number;
    status?: string;
  },
  options?: { [key: string]: any },
) {
  return request<API.AdminDailyPoolPeriodsResult>('/api/admin/activities/daily-pool/periods', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

/** 获取每日奖池期次详情 GET /api/admin/activities/daily-pool/periods/:id */
export async function getAdminDailyPoolPeriodDetail(
  id: string,
  params?: { current?: number; pageSize?: number },
  options?: { [key: string]: any },
) {
  return request<API.AdminDailyPoolPeriodDetailResult>(`/api/admin/activities/daily-pool/periods/${id}`, {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

/** 发放每日奖池奖励 POST /api/admin/activities/daily-pool/periods/:id/distribute */
export async function distributeAdminDailyPoolReward(
  id: string,
  data: { amount: number; currency: string; skipUserIds?: string[] },
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse>(`/api/admin/activities/daily-pool/periods/${id}/distribute`, {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

/** 更新每日奖池配置 PUT /api/admin/activities/daily-pool/config */
export async function updateAdminDailyPoolConfig(
  data: { minInvitesToQualify: number },
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse>('/api/admin/activities/daily-pool/config', {
    method: 'PUT',
    data,
    ...(options || {}),
  });
}

// ============ 交易记录管理 API（CRM 管理后台） ============

/** 获取全平台交易记录列表 GET /api/admin/transactions */
export async function getAdminTransactions(
  params: {
    current?: number;
    pageSize?: number;
    type?: string;
    status?: string;
    currency?: string;
    nickname?: string;
    sorter?: string;
  },
  options?: { [key: string]: any },
) {
  return request<API.AdminAllTransactionListResult>('/api/admin/transactions', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

/** 获取交易类型枚举 GET /api/admin/transactions/types */
export async function getAdminTransactionTypes(
  options?: { [key: string]: any },
) {
  return request<API.AdminTransactionTypesResult>('/api/admin/transactions/types', {
    method: 'GET',
    ...(options || {}),
  });
}

// ============ 系统设置 API（CRM 管理后台） ============

/** 获取所有系统配置 GET /api/admin/settings */
export async function getAdminSettings(options?: { [key: string]: any }) {
  return request<API.BackendResponse<API.AdminAllSettings>>('/api/admin/settings', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 更新挖矿 & 提现配置 PUT /api/admin/settings/mining */
export async function updateAdminMiningSettings(
  data: Partial<API.SettingsMining>,
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse<API.SettingsMining>>('/api/admin/settings/mining', {
    method: 'PUT',
    data,
    ...(options || {}),
  });
}

/** 更新推荐系统配置 PUT /api/admin/settings/referral */
export async function updateAdminReferralSettings(
  data: Partial<API.SettingsReferral>,
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse<API.SettingsReferral>>('/api/admin/settings/referral', {
    method: 'PUT',
    data,
    ...(options || {}),
  });
}

/** 更新新用户配置 PUT /api/admin/settings/new-user */
export async function updateAdminNewUserSettings(
  data: Partial<API.SettingsNewUser>,
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse<API.SettingsNewUser>>('/api/admin/settings/new-user', {
    method: 'PUT',
    data,
    ...(options || {}),
  });
}

/** 更新抢购全局配置 PUT /api/admin/settings/flash-sale */
export async function updateAdminFlashSaleSettings(
  data: { enabled?: boolean },
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse<{ enabled: boolean }>>('/api/admin/settings/flash-sale', {
    method: 'PUT',
    data,
    ...(options || {}),
  });
}

/** 更新积分商城全局配置 PUT /api/admin/settings/points-store */
export async function updateAdminPointsStoreSettings(
  data: { enabled?: boolean },
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse<{ enabled: boolean }>>('/api/admin/settings/points-store', {
    method: 'PUT',
    data,
    ...(options || {}),
  });
}

/** 更新每日奖池配置 PUT /api/admin/settings/daily-pool */
export async function updateAdminDailyPoolSettings(
  data: Partial<API.SettingsDailyPool>,
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse<API.SettingsDailyPool>>('/api/admin/settings/daily-pool', {
    method: 'PUT',
    data,
    ...(options || {}),
  });
}

/** 更新支付配置 PUT /api/admin/settings/payment */
export async function updateAdminPaymentSettings(
  data: Partial<API.SettingsPayment>,
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse<API.SettingsPayment>>('/api/admin/settings/payment', {
    method: 'PUT',
    data,
    ...(options || {}),
  });
}

// ============ 钱包对账 API ============

/** 获取对账摘要 GET /api/admin/reconciliation/summary */
export async function getReconciliationSummary(options?: { [key: string]: any }) {
  return request<API.BackendResponse<API.ReconciliationSummary>>('/api/admin/reconciliation/summary', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取对账日志 GET /api/admin/reconciliation/logs */
export async function getReconciliationLogs(
  params?: { page?: number; limit?: number; action?: string },
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse<{ logs: API.ReconciliationLogItem[]; pagination: { page: number; limit: number; total: number; pages: number } }>>('/api/admin/reconciliation/logs', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

/** 手动触发对账 POST /api/admin/reconciliation/run */
export async function triggerReconciliation(options?: { [key: string]: any }) {
  return request<API.BackendResponse<null>>('/api/admin/reconciliation/run', {
    method: 'POST',
    ...(options || {}),
  });
}

/** 获取提取记录 GET /api/admin/reconciliation/withdrawals */
export async function getWalletWithdrawals(
  params?: { page?: number; limit?: number },
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse<{ records: API.WalletWithdrawalItem[]; pagination: { page: number; limit: number; total: number; pages: number } }>>('/api/admin/reconciliation/withdrawals', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

/** 添加提取记录 POST /api/admin/reconciliation/withdrawals */
export async function addWalletWithdrawal(
  data: { amount: number; currency: string; amountUsdt: number; txHash?: string; note?: string },
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse<API.WalletWithdrawalItem>>('/api/admin/reconciliation/withdrawals', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

/** 删除提取记录 DELETE /api/admin/reconciliation/withdrawals/:id */
export async function deleteWalletWithdrawal(id: string, options?: { [key: string]: any }) {
  return request<API.BackendResponse<null>>(`/api/admin/reconciliation/withdrawals/${id}`, {
    method: 'DELETE',
    ...(options || {}),
  });
}

/** 更新社交活动配置 PUT /api/admin/settings/social-events */
export async function updateAdminSocialEventsSettings(
  data: Partial<API.SettingsSocialEvents>,
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse<API.SettingsSocialEvents>>('/api/admin/settings/social-events', {
    method: 'PUT',
    data,
    ...(options || {}),
  });
}

/** 更新客服联系方式配置 PUT /api/admin/settings/support */
export async function updateAdminSupportSettings(
  data: Partial<API.SettingsSupport>,
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse<API.SettingsSupport>>('/api/admin/settings/support', {
    method: 'PUT',
    data,
    ...(options || {}),
  });
}

/** 获取系统信息 GET /api/admin/settings/system-info */
export async function getAdminSystemInfo(options?: { [key: string]: any }) {
  return request<API.BackendResponse<API.AdminSystemInfo>>('/api/admin/settings/system-info', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 清除缓存 POST /api/admin/settings/clear-cache */
export async function clearAdminCache(options?: { [key: string]: any }) {
  return request<API.BackendResponse>('/api/admin/settings/clear-cache', {
    method: 'POST',
    ...(options || {}),
  });
}

/** 获取新用户矿机选项 GET /api/admin/settings/new-user-miners */
export async function getAdminNewUserMinerOptions(options?: { [key: string]: any }) {
  return request<API.BackendResponse<API.AdminNewUserMinerOption[]>>('/api/admin/settings/new-user-miners', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取 NOWPayments 全部可用币种 GET /api/admin/settings/available-currencies */
export async function getAdminAvailableCurrencies(options?: { [key: string]: any }) {
  return request<API.BackendResponse<API.CryptoCurrencyItem[]>>('/api/admin/settings/available-currencies', {
    method: 'GET',
    ...(options || {}),
  });
}

// ==================== 仪表盘 ====================

/** 获取仪表盘数据 GET /api/admin/dashboard */
export async function getAdminDashboard(options?: { [key: string]: any }) {
  return request<API.BackendResponse<API.DashboardData>>('/api/admin/dashboard', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取留存率统计 GET /api/admin/dashboard/retention */
export async function getAdminRetentionStats(options?: { [key: string]: any }) {
  return request<API.BackendResponse<API.CohortRow[]>>('/api/admin/dashboard/retention', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取付费率统计 GET /api/admin/dashboard/payment-rate */
export async function getAdminPaymentRateStats(options?: { [key: string]: any }) {
  return request<API.BackendResponse<API.CohortRow[]>>('/api/admin/dashboard/payment-rate', {
    method: 'GET',
    ...(options || {}),
  });
}

/** ROI 统计 GET /api/admin/dashboard/roi */
export async function getAdminRoiStats(options?: { [key: string]: any }) {
  return request<API.BackendResponse<API.RoiStatsResult>>('/api/admin/dashboard/roi', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 更新 ROI 成本（按日期或默认） PUT /api/admin/dashboard/roi-cost */
export async function updateAdminRoiCost(data: API.RoiCostUpdate, options?: { [key: string]: any }) {
  return request<API.BackendResponse<any>>('/api/admin/dashboard/roi-cost', {
    method: 'PUT',
    data,
    ...(options || {}),
  });
}

/** 获取渠道统计 GET /api/admin/dashboard/channels */
export async function getAdminChannelStats(options?: { [key: string]: any }) {
  return request<API.BackendResponse<API.ChannelStatsData>>('/api/admin/dashboard/channels', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 行为埋点：事件流 GET /api/admin/analytics/events */
export async function getAdminAnalyticsEvents(
  params: {
    current?: number;
    pageSize?: number;
    eventName?: string;
    uid?: string;
    pagePath?: string;
    dateStart?: string;
    dateEnd?: string;
    keyword?: string;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    data: API.AdminAnalyticsEventItem[];
    total: number;
    current: number;
    pageSize: number;
  }>('/api/admin/analytics/events', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

/** 行为埋点：用户事件 GET /api/admin/users/:id/events */
export async function getAdminUserAnalyticsEvents(
  id: string,
  params: { current?: number; pageSize?: number },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    data: API.AdminUserAnalyticsEventItem[];
    total: number;
    current: number;
    pageSize: number;
  }>(`/api/admin/users/${id}/events`, {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

/** 行为埋点：概览 GET /api/admin/analytics/overview */
export async function getAdminAnalyticsOverview(
  params: { range?: 'today' | '7d' | '30d' | 'custom'; start?: string; end?: string },
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse<API.AdminAnalyticsOverview>>(
    '/api/admin/analytics/overview',
    {
      method: 'GET',
      params,
      ...(options || {}),
    },
  );
}

/** 上传图片到 R2 POST /api/admin/upload/image */
export async function uploadAdminImage(
  file: File,
  folder?: string,
  options?: { [key: string]: any },
) {
  const formData = new FormData();
  formData.append('file', file);

  return request<API.UploadImageResult>('/api/admin/upload/image', {
    method: 'POST',
    params: folder ? { folder } : undefined,
    data: formData,
    // 不设置 Content-Type，让浏览器自动设置 multipart/form-data
    requestType: 'form',
    ...(options || {}),
  });
}


// ============ 站内信管理 API（CRM 管理后台） ============

/** 获取站内信列表 GET /api/admin/messages */
export async function getAdminMessages(
  params: {
    current?: number;
    pageSize?: number;
    type?: string;
  },
  options?: { [key: string]: any },
) {
  return request<API.AdminMessageListResult>('/api/admin/messages', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

/** 发送站内信 POST /api/admin/messages/send */
export async function sendAdminMessage(
  data: API.AdminSendMessageParams,
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse>('/api/admin/messages/send', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

/** 删除站内信 DELETE /api/admin/messages/:id */
export async function deleteAdminMessage(
  id: string,
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse>(`/api/admin/messages/${id}`, {
    method: 'DELETE',
    ...(options || {}),
  });
}


// ============ 票券商品管理 API（CRM 管理后台） ============

/** 获取票券商品列表 GET /api/admin/tickets/products */
export async function getAdminTicketProducts(
  params: {
    current?: number;
    pageSize?: number;
    isAvailable?: string;
  },
  options?: { [key: string]: any },
) {
  return request<{ success: boolean; data: any[]; total: number; current: number; pageSize: number }>(
    '/api/admin/tickets/products',
    { method: 'GET', params, ...(options || {}) },
  );
}

/** 创建票券商品 POST /api/admin/tickets/products */
export async function createAdminTicketProduct(
  data: Record<string, any>,
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse>('/api/admin/tickets/products', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

/** 更新票券商品 PUT /api/admin/tickets/products/:id */
export async function updateAdminTicketProduct(
  id: string,
  data: Record<string, any>,
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse>(`/api/admin/tickets/products/${id}`, {
    method: 'PUT',
    data,
    ...(options || {}),
  });
}

/** 删除票券商品 DELETE /api/admin/tickets/products/:id */
export async function deleteAdminTicketProduct(
  id: string,
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse>(`/api/admin/tickets/products/${id}`, {
    method: 'DELETE',
    ...(options || {}),
  });
}

/** 切换票券商品上架/下架 PATCH /api/admin/tickets/products/:id/availability */
export async function toggleAdminTicketProductAvailability(
  id: string,
  isAvailable: boolean,
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse>(`/api/admin/tickets/products/${id}/availability`, {
    method: 'PATCH',
    data: { isAvailable },
    ...(options || {}),
  });
}

// ============ 未匹配支付管理 API（CRM 管理后台） ============

/** 获取未匹配支付列表 GET /api/admin/unmatched-payments */
export async function getAdminUnmatchedPayments(
  params: {
    current?: number;
    pageSize?: number;
    status?: string;
    keyword?: string;
  },
  options?: { [key: string]: any },
) {
  return request<API.AdminUnmatchedPaymentListResult>('/api/admin/unmatched-payments', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

/** 绑定未匹配支付到订单 POST /api/admin/unmatched-payments/:id/bind */
export async function bindAdminUnmatchedPayment(
  id: string,
  orderId: string,
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse>(`/api/admin/unmatched-payments/${id}/bind`, {
    method: 'POST',
    data: { orderId },
    ...(options || {}),
  });
}

/** 忽略未匹配支付 PATCH /api/admin/unmatched-payments/:id/ignore */
export async function ignoreAdminUnmatchedPayment(
  id: string,
  note?: string,
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse>(`/api/admin/unmatched-payments/${id}/ignore`, {
    method: 'PATCH',
    data: { note },
    ...(options || {}),
  });
}

/** 删除未匹配支付 DELETE /api/admin/unmatched-payments/:id */
export async function deleteAdminUnmatchedPayment(
  id: string,
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse>(`/api/admin/unmatched-payments/${id}`, {
    method: 'DELETE',
    ...(options || {}),
  });
}

// ============ Google Play Voided Purchases API（CRM 管理后台） ============

/** 获取 voided 购买列表 GET /api/admin/voided-purchases */
export async function getAdminVoidedPurchases(
  params: {
    current?: number;
    pageSize?: number;
    status?: string;
    pendingReason?: string;
    keyword?: string;
  },
  options?: { [key: string]: any },
) {
  return request<API.AdminVoidedPurchaseListResult>('/api/admin/voided-purchases', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

/** 重新尝试自动退款 POST /api/admin/voided-purchases/:id/reprocess */
export async function reprocessAdminVoidedPurchase(
  id: string,
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse>(`/api/admin/voided-purchases/${id}/reprocess`, {
    method: 'POST',
    ...(options || {}),
  });
}

/** 标记已人工处理 PATCH /api/admin/voided-purchases/:id/resolve */
export async function resolveAdminVoidedPurchase(
  id: string,
  note?: string,
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse>(`/api/admin/voided-purchases/${id}/resolve`, {
    method: 'PATCH',
    data: { note },
    ...(options || {}),
  });
}

/** 忽略 voided 记录 PATCH /api/admin/voided-purchases/:id/ignore */
export async function ignoreAdminVoidedPurchase(
  id: string,
  note?: string,
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse>(`/api/admin/voided-purchases/${id}/ignore`, {
    method: 'PATCH',
    data: { note },
    ...(options || {}),
  });
}

// ============ 用户钱包连接 API（CRM 管理后台） ============

/** 获取用户钱包连接列表 GET /api/admin/users/:id/wallets */
export async function getAdminUserWalletConnections(
  id: string,
  params?: {
    current?: number;
    pageSize?: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.AdminWalletConnectionListResult>(`/api/admin/users/${id}/wallets`, {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

/** 调整用户余额 POST /api/admin/users/:id/adjust-balance */
export async function adjustAdminUserBalance(
  id: string,
  data: { amount: number; currency: string; reason: string },
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse>(`/api/admin/users/${id}/adjust-balance`, {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

/** 调整用户奖励算力 POST /api/admin/users/:id/adjust-reward-hashrate */
export async function adjustAdminUserRewardHashrate(
  id: string,
  data: { amount: number; reason?: string },
  options?: { [key: string]: any },
) {
  return request<{ success: boolean; data?: { id: string; rewardHashrate: number }; error?: string }>(
    `/api/admin/users/${id}/adjust-reward-hashrate`,
    {
      method: 'POST',
      data,
      ...(options || {}),
    },
  );
}

/** 获取所有用户钱包连接列表 GET /api/admin/wallets */
export async function getAdminAllWalletConnections(
  params?: {
    current?: number;
    pageSize?: number;
    keyword?: string;
    isActive?: string;
    chainId?: string;
  },
  options?: { [key: string]: any },
) {
  return request<API.AdminAllWalletConnectionListResult>('/api/admin/wallets', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

// ============ 矿机产品点击统计 API（CRM 管理后台） ============

/** 获取单个产品点击统计 GET /api/admin/miners/products/:id/click-stats */
export async function getAdminProductClickStats(
  id: string,
  params?: { days?: number },
  options?: { [key: string]: any },
) {
  return request<API.AdminProductClickStatsResult>(`/api/admin/miners/products/${id}/click-stats`, {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

/** 获取所有产品点击统计汇总 GET /api/admin/miners/click-stats */
export async function getAdminAllProductsClickStats(
  params?: { days?: number },
  options?: { [key: string]: any },
) {
  return request<API.AdminAllProductsClickStatsResult>('/api/admin/miners/click-stats', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

// ============ 促销活动管理 API（CRM 管理后台） ============

/** 获取促销列表 GET /api/admin/promotions */
export async function getAdminPromotions(options?: { [key: string]: any }) {
  return request<API.BackendResponse<API.AdminPromotionItem[]>>('/api/admin/promotions', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取促销可选产品列表 GET /api/admin/promotions/products */
export async function getAdminPromotionProducts(options?: { [key: string]: any }) {
  return request<API.BackendResponse<API.AdminPromotionProductOption[]>>('/api/admin/promotions/products', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 创建促销 POST /api/admin/promotions */
export async function createAdminPromotion(
  data: API.AdminPromotionCreateParams,
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse<API.AdminPromotionItem>>('/api/admin/promotions', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

/** 更新促销 PUT /api/admin/promotions/:id */
export async function updateAdminPromotion(
  id: string,
  data: Partial<API.AdminPromotionCreateParams>,
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse<API.AdminPromotionItem>>(`/api/admin/promotions/${id}`, {
    method: 'PUT',
    data,
    ...(options || {}),
  });
}

/** 切换促销状态 PATCH /api/admin/promotions/:id/toggle */
export async function toggleAdminPromotion(
  id: string,
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse<{ isActive: boolean }>>(`/api/admin/promotions/${id}/toggle`, {
    method: 'PATCH',
    ...(options || {}),
  });
}

/** 删除促销 DELETE /api/admin/promotions/:id */
export async function deleteAdminPromotion(
  id: string,
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse<void>>(`/api/admin/promotions/${id}`, {
    method: 'DELETE',
    ...(options || {}),
  });
}

// ============ 任务管理 API（CRM 管理后台） ============

/** 获取任务列表 GET /api/admin/tasks */
export async function getAdminTasks(
  params?: { current?: number; pageSize?: number; status?: string; conditionType?: string },
  options?: { [key: string]: any },
) {
  return request<API.AdminTaskListResult>('/api/admin/tasks', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

/** 创建任务 POST /api/admin/tasks */
export async function createAdminTask(
  data: API.AdminTaskCreateParams,
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse<API.AdminTaskItem>>('/api/admin/tasks', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

/** 更新任务 PUT /api/admin/tasks/:id */
export async function updateAdminTask(
  id: string,
  data: Partial<API.AdminTaskCreateParams>,
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse<API.AdminTaskItem>>(`/api/admin/tasks/${id}`, {
    method: 'PUT',
    data,
    ...(options || {}),
  });
}

/** 删除任务 DELETE /api/admin/tasks/:id */
export async function deleteAdminTask(id: string, options?: { [key: string]: any }) {
  return request<API.BackendResponse<void>>(`/api/admin/tasks/${id}`, {
    method: 'DELETE',
    ...(options || {}),
  });
}

/** 切换任务启用状态 PATCH /api/admin/tasks/:id/toggle */
export async function toggleAdminTask(id: string, options?: { [key: string]: any }) {
  return request<API.BackendResponse<{ status: string }>>(`/api/admin/tasks/${id}/toggle`, {
    method: 'PATCH',
    ...(options || {}),
  });
}

// ============ Q&A Management ============

/** 获取 Q&A 列表 GET /api/admin/qa */
export async function getAdminQaList(
  params?: { current?: number; pageSize?: number; status?: string },
  options?: { [key: string]: any },
) {
  return request<API.AdminQaListResult>('/api/admin/qa', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

/** 创建 Q&A POST /api/admin/qa */
export async function createAdminQa(
  data: API.AdminQaCreateParams,
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse<API.AdminQaItem>>('/api/admin/qa', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

/** 更新 Q&A PUT /api/admin/qa/:id */
export async function updateAdminQa(
  id: string,
  data: Partial<API.AdminQaCreateParams>,
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse<API.AdminQaItem>>(`/api/admin/qa/${id}`, {
    method: 'PUT',
    data,
    ...(options || {}),
  });
}

/** 删除 Q&A DELETE /api/admin/qa/:id */
export async function deleteAdminQa(id: string, options?: { [key: string]: any }) {
  return request<API.BackendResponse<void>>(`/api/admin/qa/${id}`, {
    method: 'DELETE',
    ...(options || {}),
  });
}

/** 切换 Q&A 启用状态 PATCH /api/admin/qa/:id/toggle */
export async function toggleAdminQa(id: string, options?: { [key: string]: any }) {
  return request<API.BackendResponse<{ status: string }>>(`/api/admin/qa/${id}/toggle`, {
    method: 'PATCH',
    ...(options || {}),
  });
}

// ============ RBAC System Management ============

/** 获取权限树 GET /api/admin/system/permissions */
export async function getPermissionTree(options?: { [key: string]: any }) {
  return request<API.BackendResponse<{ tree: API.PermissionTreeNode[]; allKeys: string[] }>>(
    '/api/admin/system/permissions',
    { method: 'GET', ...(options || {}) },
  );
}

/** 获取角色列表 GET /api/admin/system/roles */
export async function getSystemRoles(options?: { [key: string]: any }) {
  return request<API.BackendResponse<API.AdminRoleItem[]>>('/api/admin/system/roles', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取角色详情 GET /api/admin/system/roles/:id */
export async function getSystemRoleDetail(id: string, options?: { [key: string]: any }) {
  return request<API.BackendResponse<API.AdminRoleItem>>(`/api/admin/system/roles/${id}`, {
    method: 'GET',
    ...(options || {}),
  });
}

/** 创建角色 POST /api/admin/system/roles */
export async function createSystemRole(
  data: { name: string; description?: string; permissions: string[] },
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse<API.AdminRoleItem>>('/api/admin/system/roles', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

/** 更新角色 PUT /api/admin/system/roles/:id */
export async function updateSystemRole(
  id: string,
  data: { name?: string; description?: string; permissions?: string[] },
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse<API.AdminRoleItem>>(`/api/admin/system/roles/${id}`, {
    method: 'PUT',
    data,
    ...(options || {}),
  });
}

/** 删除角色 DELETE /api/admin/system/roles/:id */
export async function deleteSystemRole(id: string, options?: { [key: string]: any }) {
  return request<API.BackendResponse<void>>(`/api/admin/system/roles/${id}`, {
    method: 'DELETE',
    ...(options || {}),
  });
}

/** 获取管理员账户列表 GET /api/admin/system/accounts */
export async function getSystemAccounts(options?: { [key: string]: any }) {
  return request<API.BackendResponse<API.AdminAccountItem[]>>('/api/admin/system/accounts', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 创建管理员账户 POST /api/admin/system/accounts */
export async function createSystemAccount(
  data: { username: string; email: string; password: string; roleId?: string },
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse<any>>('/api/admin/system/accounts', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

/** 更新管理员账户 PUT /api/admin/system/accounts/:id */
export async function updateSystemAccount(
  id: string,
  data: { username?: string; status?: string; roleId?: string },
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse<any>>(`/api/admin/system/accounts/${id}`, {
    method: 'PUT',
    data,
    ...(options || {}),
  });
}

/** 删除管理员账户 DELETE /api/admin/system/accounts/:id */
export async function deleteSystemAccount(id: string, options?: { [key: string]: any }) {
  return request<API.BackendResponse<void>>(`/api/admin/system/accounts/${id}`, {
    method: 'DELETE',
    ...(options || {}),
  });
}

/** 重置管理员密码 POST /api/admin/system/accounts/:id/reset-password */
export async function resetSystemAccountPassword(
  id: string,
  data: { password: string },
  options?: { [key: string]: any },
) {
  return request<API.BackendResponse<void>>(`/api/admin/system/accounts/${id}/reset-password`, {
    method: 'POST',
    data,
    ...(options || {}),
  });
}
